export const BASE_URL = 'https://stockulator.herokuapp.com/api';
